<template>
	<el-dialog :title="type=='Add'?'新增产品':'编辑产品'" :visible.sync="outerVisible" :before-close="beforeClose">
		<el-form :model="productModel" label-width="80px">
			<el-form-item label="产品名称">
				<el-input v-model="productModel.name"></el-input>
			</el-form-item>
			<el-form-item label="所属分类">
				<el-select v-model="productModel.categoryID">
					<el-option v-for="item in proCategoryList" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="缩略图">
				<vue-cropper2 @upfile="upicon" :defaultIcon="productModel.img?($http.fileUrl+productModel.img):''"
					:width="553" :height="311" style="margin-left: 14px;" path="ProductImg">
				</vue-cropper2>
			</el-form-item>
			<el-form-item label="产品介绍">
				<el-input type="textarea" v-model="productModel.introduce" style="width: 500px;"></el-input>
			</el-form-item>
			<el-form-item label="场景名称">
				<el-input v-model="productModel.sceneName"></el-input>
			</el-form-item>
			<el-form-item label="案例欣赏">
				<el-upload class="upload-demo" :action="$http.defaults.baseURL+'api/ToolApi/UpFiles'"
					:data="{path:'ProductImg'}" :headers="{'Authorization': 'Bearer ' + $http.token}"
					:on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList"
					:on-success="UpFileSuccess" list-type="picture">
					<el-button size="small" type="primary">点击上传</el-button>
					<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
				</el-upload>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button @click="beforeClose">取 消</el-button>
			<el-button type="primary" @click="saveProduct()">保存</el-button>
		</div>
		<!-- <input type="file" @change="getFile($event)" class="form-control"> -->
	</el-dialog>
</template>

<script>
	import vueCropper2 from '@/components/vue-cropper2'
	export default {
		data() {
			return {
				productImgModel: {
					id: '',
					Name: '',
					ProductID: '',
					FileType: '',
					FileSize: '',
					FileUrl: ''
				},
				fileList: []
			}
		},
		props: {
			type: {
				type: String,
				default: 'Add'
			},
			productModel: {
				type: Object
			},
			outerVisible: {
				type: Boolean,
				default: false
			},
			proCategoryList: {
				type: Array
			}
		},
		components: {
			vueCropper2
		},
		watch: {
			type(val) {

				if (val == "Add") {
					this.fileList = []
				} else {
					this.fileList = []
					this.$http.get('api/Product/Product_Files/' + this.productModel.id).then(res => {
						res.data.data.map(a => {
							this.fileList.push({
								name: a.name,
								url: this.$http.fileUrl + a.fileUrl,
								size: a.fileSize
							})
						})
					})
				}
			}
		},
		methods: {
			handleRemove(file, fileList) {
				this.fileList = fileList
			},
			handlePreview(file) {},
			UpFileSuccess(response, file, fileList) {

				if (JSON.stringify(file).indexOf('身份认证失败,未获取授权') > -1) {
					this.$message({
						message: "身份认证失败，刷新页面重试",
						type: 'info'
					})
					window.location.reload()
				}
				this.fileList = fileList
			},
			upicon(e) {
				this.productModel.img = e;
			},
			async saveProduct() {
				if (this.productModel.name == '' || this.productModel.name == null) {
					this.$message({
						message: "产品名称不能为空",
						type: 'info'
					})
				} else if (this.productModel.categoryID == '' || this.productModel.categoryID == null) {
					this.$message({
						message: "请选择产品分类",
						type: 'info'
					})
				} else if (this.productModel.img == '' || this.productModel.img == null) {
					this.$message({
						message: "请上传产品缩略图",
						type: 'info'
					})
				} else if (this.productModel.introduce == '' || this.productModel.introduce == null) {
					this.$message({
						message: "请输入产品介绍",
						type: 'info'
					})
				} else if (this.fileList.length == 0) {
					this.$message({
						message: "请上传产品案例图片",
						type: 'info'
					})
				} else {
					this.productModel.img = this.productModel.img.replace(this.$http.fileUrl, '')

					if (!this.productModel.id) {
						this.productModel.id = this.$guid.guid()
					}

					//删除 原有记录
					if (this.type == "Up") {
						await this.$http.get('api/Product/DelProduct_Files/' + this.productModel.id).then(res => {})
					}

					this.fileList.map(a => {
						let url = ''
						if (a.url.indexOf('blob:') == -1) {
							url = a.url.replace(this.$http.fileUrl, '')
						} else {
							url = a.response.data
						}

						this.productImgModel.Name = a.name
						this.productImgModel.FileUrl = url
						this.productImgModel.FileSize = a.size
						this.productImgModel.ProductID = this.productModel.id
						this.productImgModel.FileType = 'pic'

						//保存 欣赏案例信息
						this.$http.post('api/Product/SaveProduct_Files', this.productImgModel).then(res => {
							if (res.data.code != '1') {
								this.$message({
									message: "案例欣赏-保存失败",
									type: 'error'
								})
							}
						})
					})

					//保存 产品信息
					this.$http.post('api/Product/EditProducts', this.productModel).then(res => {
						if (res.data.code == '1') {
							this.$message({
								message: "产品记录保存成功",
								type: 'success'
							})
							this.beforeClose(true)
						} else {
							this.$message({
								message: "产品记录保存失败",
								type: 'error'
							})
						}
					})
				}
			},
			beforeClose(val) {
				this.$emit('before-Close', val)
			}
		}
	}
</script>

<style>
</style>
